module.exports = __webpack_public_path__ + "img/custom.69c32b70.png";